// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"681f5cf2","876":"c63ae05b","932":"5818f68d"}[chunkId] + ".chunk.js";
};